import { UserState } from 'src/app/global/state/app.reducers';
import { UbState } from './ub.reducer';
import * as UbActions from './ub.actions';
import * as UbSelectors from './ub.selectors';

export interface State extends UserState {
    ubState: UbState
}

export { UbActions, UbSelectors };